module.exports = __webpack_public_path__ + "assets/fly.49bfb3b4d57be32465c6bd2276bc5b3c.png";